exports.ProductionTypeList = [{
	value: '1',
	label: '自制'
}, {
	value: '2',
	label: '委外'
}];
exports.StatusList= [
	{
		Status: -1,
		StatusName: '全部状态'
	},
	{
	Status: 0,
	StatusName: '未审核'
}, {
	Status: 1,
	StatusName: '已审核'
}];


// WEBPACK FOOTER //
// ./src/common/js/global-json.js